var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"MenuBtn",class:{ active: _vm.active }},_vm.$listeners),[_c('span',{staticClass:"line1"}),_c('span',{staticClass:"line2"}),_c('span',{staticClass:"line3"})])}
var staticRenderFns = []

export { render, staticRenderFns }